<template>
  <div class="fail-bg" @click.stop>
    <img class="close-icon" src="~/assets/imgs/detail_close.png" @click="close" />
    <div class="title">提示</div>
    <div class="content-error" v-html="desc"></div>
    <div class="footer">
      <div class="confirm" @click="confirm">{{ text }}</div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { defineEmits, defineProps } from "vue";
import { isGameInstall, pandora } from "~/utils";
import { getContentGameInfo } from "@@/alova";
import { isEmptyString } from "@metaapp/utils";

const emit = defineEmits(["close"]);
const props = withDefaults(
  defineProps<
    Partial<{
      failCode: number;
      failMessage: string;
      detail: any;
      exchangeCount: number;
    }>
  >(),
  {
    failCode: 0,
    failMessage: "",
    detail: {}
  }
);
const desc = ref("");

const text = ref<"确定" | "下载游戏" | "打开游戏">("确定");
/**
 * @description 关闭弹窗
 * @return {void}
 */
const close = (): void => {
  if (text.value !== "确定") {
    text.value = "确定";
  }
  emit("close");
};
/**
 * @description 关闭弹窗
 * @return {Promise<void>} --
 */
const confirm = async (): Promise<void> => {
  if (text.value === "下载游戏") {
    jsb?.execAsyncV2("goDetail", props.detail.gameId);
  }
  if (text.value === "打开游戏") {
    const data = await getContentGameInfo({ id: props.detail.gameId });
    jsb?.execAsyncV2("playGame", JSON.stringify(data));
  }
  close();
};
/**
 * 领取奖品失败
 * @param {number} code 获取到的code值
 * @returns {Promise<void>} --
 */
const getpricefail = async (code: number): Promise<void> => {
  switch (code) {
    case 900001:
      desc.value = "商品不存在或已下架~";
      break;
    case 900002:
      desc.value = "商品已售罄~";
      break;
    case 900003:
      desc.value = "购买达到上限~";
      break;
    case 900004:
      desc.value = "乐币不足~";
      break;
    case 900005:
      desc.value = "不是会员~";
      break;
    case 900006:
      desc.value = "商品库存不足~";
      break;
    case 900007:
      desc.value = "订单创建异常~";
      break;
    case 900008:
      desc.value = "物品发送失败~";
      break;
    case 900009:
      desc.value = "购买数量超过个人购买限制数量~";
      break;
    case 900010:
      desc.value = "订单支付异常";
      break;
    case 900011:
      desc.value = "请实名认证后再进行兑换！";
      break;
    case 900012:
      desc.value = "订单已支付超时，无法支付，请重新下单支付";
      break;
    case 900013:
      desc.value = "短信验证码下发异常，请稍后重新下单！";
      break;
    case 1002:
      desc.value = "验证码失效/失败，请重新尝试";
      break;
    case 1030:
      desc.value = "移动短信发送需要间隔60秒，请稍后重试";
      break;
    case 1017:
      desc.value = "该手机已绑定其他账户，请使用其他手机号进行绑定";
      break;
    case 900014:
      desc.value = props.failMessage;
      break;
    case 900015:
      desc.value = props.failMessage;
      break;
    case 900016:
      desc.value = props.failMessage;

      if (!isEmptyString(props.detail.gameId) && !(await isGameInstall(props.detail.gameId))) {
        text.value = "下载游戏";
        break;
      }
      text.value = "打开游戏";
      break;
    default:
      desc.value = "服务器异常~";
      break;
  }
  pandora("event_goods_shop_detail_exchange_result", "福利商店商品兑换结果", {
    merchandise_id: sessionStorage.getItem("commodityId") || "",
    merchandise_name: props.detail.name,
    status: props.detail.status,
    exchange_type: props.detail.paymentType,
    reason: desc.value,
    goods_type: props.detail.propType,
    result: "fail",
    exchange_num: props.exchangeCount,
    exchange_cost:
      props.detail.price && props.detail.price * (props.exchangeCount ? props.exchangeCount : 1)
  });
};
onMounted(() => {
  getpricefail(props.failCode);
});
</script>
<style scoped lang="scss">
.fail-bg {
  width: 13.25rem;
  background: #fff;
  position: relative;
  border-radius: 0.5rem;

  .close-icon {
    width: 0.9rem;
    height: 0.9rem;
    position: absolute;
    top: 0.6rem;
    right: 0.6rem;
  }

  .title {
    margin: 0.65rem 0 1.24rem 0;
    text-align: center;
    font-size: 0.685rem;
    font-weight: 600;
  }

  .content-error {
    color: #000;
    font-size: 0.685rem;
    font-weight: 600;
    text-align: center;
    padding: 0 1rem;
  }

  .footer {
    font-size: 0.7rem;
    display: flex;
    justify-content: center;

    .confirm {
      height: 1.68rem;
      line-height: 1.68rem;
      width: 50%;
      background: #ff7210;
      color: #fff;
      text-align: center;
      border-radius: 1rem;
      margin: 1.3rem 0 0.88rem 0;
    }
  }
}
</style>
